import { ChangeDetectionStrategy, Component } from '@angular/core';

import { LOCAL_DEVICES, QUEUE_CLERKS } from '../../data/walkthrough.fixtures';

/**
 * Pane 7 / 8 — `Local-first operation` (specs/auth.md §5.4).
 *
 * The most bespoke illustration in the feature: seven stacked pieces — a
 * register hub, a CSS-drawn connector under a label, three device tiles, a
 * rule, a horizontal queue flow, a sync pill and a footnote. Nothing in it is
 * reused by any other pane, and §10 says in as many words not to generalise it.
 *
 * It is also the one place the offline promise is made as a DIAGRAM rather than
 * as a sentence, which is why the pane is the whole answer to §9's "where is
 * offline stated" for the walkthrough — there is no breakpoint-dependent
 * variant here the way Login and Signup have one.
 *
 * ⚠ Inert. Devices do not connect, the queue does not move, and the sync pill
 * reports nothing: there is no `navigator.onLine` check anywhere in this
 * feature (§9). Offline is the SUBJECT of this pane, never a state of it.
 */
@Component({
  selector: 'app-walkthrough-pane7',
  standalone: false,
  templateUrl: './walkthrough-pane7.component.html',
  styleUrls: ['./walkthrough-pane7.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalkthroughPane7Component {
  readonly devices = LOCAL_DEVICES;
  readonly clerks = QUEUE_CLERKS;
}
